export default (color, n = 1) => {
    // 16进制颜色值的正则
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 把颜色值变成小写
    let newColor = color.toLowerCase();
    if (reg.test(newColor)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (newColor.length === 4) {
            let colorNew = '#';
            for (let i = 1; i < 4; i += 1) {
                colorNew += newColor.slice(i, i + 1).concat(newColor.slice(i, i + 1));
            }
            newColor = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = [];
        for (let i = 1; i < 7; i += 2) {
            colorChange.push(parseInt(`0x${newColor.slice(i, i + 2)}`));
        }
        return `rgba(${colorChange.join(',')},${n})`;
    } else {
        return newColor;
    }
};
